import React, { MutableRefObject } from "react";

import { Card as AntCard, CardProps as AntCardProps } from "antd";

import { trackMixpanel } from "utils";

export type CardProps = AntCardProps & {
  dataTestId?: string;
  mixpanelText?: string;
  customRef?: MutableRefObject<HTMLDivElement>;
};

export const Card = ({ children, onClick, dataTestId, mixpanelText, customRef, ...props }: CardProps) => (
  <AntCard
    data-testid={dataTestId}
    onClick={(e) => {
      if (onClick) {
        trackMixpanel("ClickCard", { type: mixpanelText || "undefined" });
        onClick(e);
      }
    }}
    ref={customRef}
    {...props}
  >
    {children}
  </AntCard>
);

export default Card;
